import { useEffect, useState } from "react";
import Button from "../../../common/Button";
import PayerTypeStatusRepeaterOption from "./PayerTypeStatusRepeaterOption";

export default function PayerTypeStatusRepeater({classes, item, mainSelectAction, filtersValues, workQ, removepayerTypeStatus}) {

    const [groups, setGroups] = useState([{
        payer_type_id: null, 
        payer_status_id: null
    }])

    function addRepeaterItemHandler() {
        setGroups(prev => [...prev, {
            payer_type_id: null, 
            payer_status_id: null
        }])
    }

    useEffect(() => {
        if (filtersValues && filtersValues.payer_type_filters && filtersValues.payer_type_filters.length) { 
            setGroups(filtersValues.payer_type_filters)
        } else {
            setGroups([{
                payer_type_id: null, 
                payer_status_id: null
            }])
        }

    }, [filtersValues])

    return <div className={` ${classes.payer_type_status_container}`}>
        {groups && groups.map((groupRepeater, index) => (
            <div key={index} className={classes.repeater_item}>
                <PayerTypeStatusRepeaterOption classes={classes} filterItem={groupRepeater} itemIndex={index} mainSelectAction={mainSelectAction} itemData={item} workQ={workQ} hasRemove={index != groups.length-1}/>
                
                {index == groups.length-1 ? <div>
                    <Button click={addRepeaterItemHandler}><i className="ti ti-plus"></i></Button>
                </div>
                :
                <></>
                }
            </div>  
        ))} 
    </div>
}